import React from 'react';

const Pagination = ({
  pageSize,
  pageIndex,
  pageCount,
  canPreviousPage,
  canNextPage,
  gotoPage,
  previousPage,
  nextPage
}) => {
  return (
    <div className="Explorer-Journals-Pagination-Container">
      <button
        type="button"
        className="btn--first"
        onClick={() => gotoPage(0)}
        disabled={!canPreviousPage}
        aria-label="Go to first page"
      >
        {'<<'}
      </button>
      <button
        type="button"
        className="btn--previous"
        onClick={previousPage}
        disabled={!canPreviousPage}
        aria-label="Go to previous page"
      >
        {'<'}
      </button>
      <span>
        {I18n.htmlSafe('Explorer.Journals.pagination.current_page_info', {
          currentPage: pageIndex + 1,
          pageCount
        })}
      </span>
      <button
        type="button"
        className="btn--next"
        onClick={nextPage}
        disabled={!canNextPage}
        aria-label="Go to next page"
      >
        {'>'}
      </button>
      <button
        type="button"
        className="btn--last"
        onClick={() => gotoPage(pageCount - 1)}
        disabled={!canNextPage}
        aria-label="Go to last page"
      >
        {'>>'}
      </button>
      <span> {I18n.htmlSafe('Explorer.Journals.pagination.results_per_page', { pageSize })}</span>
    </div>
  );
};

export default Pagination;
